import { FiFileText } from '@react-icons/all-files/fi/FiFileText'

// order/order-item note

export const IconNote = FiFileText
